import React from 'react';
import { Link } from 'react-router-dom';

interface PageHeroProps {
  title: string;
  breadcrumb?: string;
}

export function PageHero({ title, breadcrumb }: PageHeroProps) {
  return (
    <section className="relative w-full h-[380px] pt-[80px] bg-black flex items-center justify-center">
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/60"></div>
      <div className="relative z-10 text-center">
        <h1 className="text-white font-display font-bold text-[36px] md:text-[48px] uppercase tracking-wider mb-4">
          {title}
        </h1>
        {breadcrumb && (
          <div className="flex items-center justify-center gap-2 text-white/70 text-[14px]">
            <Link to="/" className="hover:text-white transition-colors">Home</Link>
            <span>/</span>
            <span className="text-white">{breadcrumb}</span>
          </div>
        )}
      </div>
    </section>
  );
}
